// import { useState } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import Button from '@mui/material/Button';

import classes from './UdcCard.module.css';

const UdcCard = props => {
  return (
    <Button
      className={classes.cardContainer}
      component={Link}
      to={`/product/${props.section}/${props.itemData.link}`}
    >
      <aside className={classes.leftSection}>
        <p className={classes.cardTitle}>Licenciatura</p>
        <figure className={classes.udcCardImage}>
          <img src={props.itemData.img} className={classes.img} />
        </figure>
        <p className={classes.warningText}>Destacado</p>
      </aside>
      <aside className={classes.complementaryInfoContainer}>
        <p className={classes.udcCardTitle}>
          {props.itemData.title}
        </p>
        <p className={classes.udcCardDescription}>
          {props.itemData.description}
        </p>
        <p className={classes.seeMoreText}>Conocer más</p>
      </aside>
    </Button>
  );
};

UdcCard.propTypes = {
  // eslint-disable-next-line react/require-default-props
  itemData: PropTypes.object,
  // eslint-disable-next-line react/require-default-props
  section: PropTypes.string
};

export default UdcCard;
